export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "career_path": "మీ జీవితానికి అనుకూలమైన ఉత్తమ కెరీర్ మార్గం ఏమిటో తెలుసుకోండి",
    "professional_destiny_analysis": "వృత్తిపరమైన విధి విశ్లేషణ",
    "career_report_description": "వేద జ్యోతిష్యం ఆధారంగా సమగ్ర కెరీర్ విశ్లేషణతో మీ వృత్తిపరమైన సంభావ్యతను అన్‌లాక్ చేయండి. అనువైన కెరీర్ మార్గాలు, వ్యాపార అవకాశాలు, కెరీర్ మార్పుల సమయం మరియు వృత్తిపరమైన విజయానికి వ్యూహాలపై అంతర్దృష్టులను పొందండి.",

    // Service Information
    "enter_details_for_career_analysis": "కెరీర్ విశ్లేషణ కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_career_analysis": "పూర్ణ కెరీర్ విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_career_analysis_note": "మీ వృత్తిపరమైన సంభావ్యత మరియు కెరీర్ రోడ్‌మ్యాప్ యొక్క లోతైన విశ్లేషణ",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_career_influence": "మీ పేరు మీ వృత్తిపరమైన ప్రతిష్ట మరియు విజయ నమూనాలను ప్రభావితం చేస్తుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_career_path": "మీ కెరీర్-ఆధారిత గ్రహ స్థానాలను నిర్ధారించడానికి అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_critical_for_career": "ఖచ్చితమైన కెరీర్ భావ గణనల కోసం ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_essential_for_career": "స్థానం కెరీర్‌ను ప్రభావితం చేసే గ్రహ స్థానాలను ప్రభావితం చేస్తుంది",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ కెరీర్ విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Career Features
    "ideal_career_paths": "అనువైన కెరీర్ మార్గాలు",
    "professional_strengths_analysis": "వృత్తిపరమైన బలాల విశ్లేషణ",
    "business_prospects_guidance": "వ్యాపార అవకాశాల మార్గదర్శనం",
    "career_timing_predictions": "కెరీర్ సమయ భవిష్యవాణులు",
    "skill_development_recommendations": "నైపుణ్య అభివృద్ధి సిఫార్సులు",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ కెరీర్ విశ్లేషణలో ఉన్నవి",
    "detailed_career_roadmap": "వివరణాత్మక కెరీర్ రోడ్‌మ్యాప్",
    "professional_strengths_weaknesses": "వృత్తిపరమైన బలాలు మరియు బలహీనతలు",
    "business_entrepreneurship_guidance": "వ్యాపారం మరియు వ్యవసాయ మార్గదర్శనం",
    "career_transition_timing": "కెరీర్ మార్పు సమయం",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా కెరీర్ విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "career_analysis_processing": "మీ కెరీర్ విశ్లేషణ మా నిపుణ వేద జ్యోతిష్యులచే తయారు చేయబడుతోంది. మీ వృత్తిపరమైన సంభావ్యత మరియు అనువైన కెరీర్ మార్గాలపై వివరణాత్మక అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_12_hours_delivery_note": "మీ వివరణాత్మక కెరీర్ నివేదిక 12 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ కెరీర్ విశ్లేషణ ప్యాకేజ్",
    "detailed_career_report": "సమగ్ర కెరీర్ నివేదిక (PDF)",
    "suitable_career_options": "అనువైన కెరీర్ ఎంపికలు మరియు రంగాలు",
    "professional_development_plan": "వృత్తిపరమైన అభివృద్ధి ప్రణాళిక",
    "success_timing_analysis": "విజయ సమయ విశ్లేషణ",
    "entrepreneurship_assessment": "వ్యవసాయ అంచనా",

    // Visual Content
    "sample_career_analysis": "నమూనా కెరీర్ విశ్లేషణ",
    "ideal_career_field": "అనువైన కెరీర్ రంగం",
    "sample_career_description": "టెక్నాలజీ మరియు ఇన్నోవేషన్ - బలమైన విశ్లేషణాత్మక మరియు నాయకత్వ సామర్థ్యాలు",
    "sample_career_preview": "రంగ సిఫార్సులతో మీ వ్యక్తిగత కెరీర్ విశ్లేషణ మునుజూపు",
    "career_fields": "కెరీర్ రంగాలు",

    // Career Field Types
    "technology": "టెక్నాలజీ",
    "healthcare": "ఆరోగ్య సంరక్షణ",
    "finance": "ఆర్థిక వ్యవహారాలు",
    "creative_arts": "సృజనాత్మక కళలు",
    "education": "విద్య",
    "business": "వ్యాపారం",

    // Status & Processing
    "your_career_analysis_status": "మీ కెరీర్ విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ కెరీర్ సంభావ్యతను విశ్లేషిస్తోంది",
    "analysis_processing_message": "మా వేద జ్యోతిష్య నిపుణులు మీ అనువైన కెరీర్ మార్గం మరియు వృత్తిపరమైన సమయాన్ని నిర్ధారించడానికి మీ గ్రహ స్థానాలను అధ్యయనం చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_12_hours": "12 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "కెరీర్ మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Career-Specific Elements
    "tenth_house": "10వ భావం (కెరీర్ భావం)",
    "ascendant_lord": "లగ్న స్వామి",
    "career_planets": "కెరీర్-ప్రభావిత గ్రహాలు",
    "professional_dasha": "వృత్తిపరమైన దశా కాలాలు",
    "career_yogas": "కెరీర్ యోగాలు",
    "success_indicators": "విజయ సూచికలు",

    // Career Analysis Sections
    "natural_talents": "సహజ ప్రతిభలు మరియు సామర్థ్యాలు",
    "professional_personality": "వృత్తిపరమైన వ్యక్తిత్వం",
    "leadership_qualities": "నాయకత్వ గుణాలు",
    "work_preferences": "పని వాతావరణ ప్రాధాన్యతలు",
    "career_motivations": "కెరీర్ ప్రేరణలు",
    "professional_challenges": "వృత్తిపరమైన సవాళ్లు",

    // Suitable Career Paths
    "recommended_careers": "సిఫార్సు చేయబడిన కెరీర్ మార్గాలు",
    "alternative_careers": "ప్రత్యామన్న కెరీర్ ఎంపికలు",
    "avoid_careers": "తప్పించవలసిన కెరీర్లు",
    "freelancing_potential": "ఫ్రీలాన్సింగ్ సంభావ్యత",
    "government_vs_private": "ప్రభుత్వ వర్సెస్ ప్రైవేట్ రంగం",
    "international_opportunities": "అంతర్జాతీయ కెరీర్ అవకాశాలు",

    // Business & Entrepreneurship
    "business_acumen": "వ్యాపార తెలివితేటలు",
    "entrepreneurial_skills": "వ్యవసాయ నైపుణ్యాలు",
    "partnership_compatibility": "వ్యాపార భాగస్వామ్య అనుకూలత",
    "investment_timing": "పెట్టుబడి సమయం",
    "business_sectors": "అనువైన వ్యాపార రంగాలు",
    "startup_potential": "స్టార్ట్‌అప్ విజయ సంభావ్యత",

    // Professional Development
    "skill_enhancement": "నైపుణ్య మెరుగుదల రంగాలు",
    "educational_recommendations": "విద్యా సిఫార్సులు",
    "certification_suggestions": "సర్టిఫికేషన్ సూచనలు",
    "mentorship_guidance": "మెంటార్‌షిప్ మార్గదర్శనం",
    "networking_strategies": "నెట్‌వర్కింగ్ వ్యూహాలు",
    "personal_branding": "వ్యక్తిగత బ్రాండింగ్ చిట్కాలు",

    // Career Timing
    "career_growth_periods": "కెరీర్ వృద్ధి కాలాలు",
    "job_change_timing": "అనువైన ఉద్యోగ మార్పు సమయం",
    "promotion_periods": "ప్రమోషన్ అనుకూల కాలాలు",
    "salary_negotiation_timing": "జీతం చర్చల సమయం",
    "business_launch_timing": "వ్యాపార ప్రారంభ సమయం",
    "retirement_planning": "పదవీ విరమణ ప్రణాళిక మార్గదర్శనం",

    // Success Strategies
    "professional_networking": "వృత్తిపరమైన నెట్‌వర్కింగ్",
    "workplace_relationships": "కార్యాలయ సంబంధాలు",
    "conflict_resolution": "వివాద పరిష్కార నైపుణ్యాలు",
    "stress_management": "వృత్తిపరమైన ఒత్తిడి నిర్వహణ",
    "work_life_balance": "పని-జీవిత సంతులనం",
    "career_setback_recovery": "కెరీర్ ఎదురుదెబ్బ రికవరీ",

    // Financial Aspects
    "earning_potential": "సంపాదన సంభావ్యత",
    "wealth_accumulation": "సంపద సంచయన నమూనాలు",
    "financial_planning": "ఆర్థిక ప్రణాళిక సలహా",
    "investment_guidance": "పెట్టుబడి మార్గదర్శనం",
    "passive_income_opportunities": "నిష్క్రియ ఆదాయ అవకాశాలు",
    "financial_security_timing": "ఆర్థిక భద్రత కాలక్రమం",

    // Industry-Specific Guidance
    "it_software": "IT మరియు సాఫ్ట్‌వేర్",
    "banking_finance": "బ్యాంకింగ్ మరియు ఫైనాన్స్",
    "healthcare_medical": "ఆరోగ్య సంరక్షణ మరియు వైద్యం",
    "education_training": "విద్య మరియు శిక్షణ",
    "media_entertainment": "మీడియా మరియు వినోదం",
    "manufacturing_engineering": "తయారీ మరియు ఇంజినీరింగ్",
    "sales_marketing": "విక్రయాలు మరియు మార్కెటింగ్",
    "consulting_services": "కన్సల్టింగ్ మరియు సేవలు",

    // Professional Relationships
    "boss_relationships": "ఉన్నతాధికారులతో సంబంధాలు",
    "colleague_dynamics": "సహోద్యోగుల డైనామిక్స్",
    "team_leadership": "టీమ్ నాయకత్వ శైలి",
    "client_relationships": "క్లయింట్ సంబంధ నిర్వహణ",
    "vendor_partnerships": "విక్రేత మరియు భాగస్వామ్య నిర్వహణ",

    // Career Remedies
    "career_remedies": "కెరీర్ మెరుగుదల పరిహారాలు",
    "professional_gemstones": "వృత్తిపరమైన రత్నాలు",
    "career_mantras": "కెరీర్ విజయ మంత్రాలు",
    "workplace_vastu": "కార్యాలయ వాస్తు చిట్కాలు",
    "professional_colors": "వృత్తిపరమైన అదృష్ట రంగులు",
    "career_fasting": "కెరీర్-లాభదాయకమైన ఉపవాసం"
};
